import TestResult from './TestResult';

export default TestResult;
